import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SolarApplicationsService } from 'src/app/services/service-provider.service';

@Component({
  selector: 'app-provider-dash',
  templateUrl: './provider-dash.component.html',
  styleUrls: ['./provider-dash.component.scss'],
})
export class ProviderDashComponent implements OnInit {
  applicationsStates: any[] = []; 
  totalProsumers: number = 0;
  totalConsumers: number = 0;
  totalUsers: number = 0;

  constructor(
    private solarApplicationsService: SolarApplicationsService, 
    private router: Router
  ) {}

  ngOnInit() {
    this.fetchApplicationsStates(); 
    this.fetchUsersGroupedByType();
  }

  fetchApplicationsStates(): void {
    this.solarApplicationsService.getApplicationsStates().subscribe({
      next: (data) => {
        this.applicationsStates = data.items;
        console.log(this.applicationsStates);
      },
      error: (error) => {
        console.error('Error fetching applications:', error); 
      }
    });
  }

  fetchUsersGroupedByType(): void {
    this.solarApplicationsService.getUsersGroupedByType().subscribe({
      next: (data) => {
        this.totalProsumers = data.find((item: any) => item.type === 'Prosumer')?.total || 0;
        this.totalConsumers = data.find((item: any) => item.type === 'Consumer')?.total || 0;
        this.totalUsers = data.reduce((acc: number, item: any) => acc + item.total, 0); 
      },
      error: (error) => {
        console.error('Error fetching users grouped by type:', error);
      }
    });
  }

  goToApplicationsReceived(applicationStateId: string): void {
    this.router.navigate([`/applications/${applicationStateId}`]);
  }
}
